import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import Controls from '@stories/Components/Carousels/Carousel/Controls/Controls';
import MotionTrack from '@stories/Components/Carousels/Carousel/MotionTrack/MotionTrack';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --visibleItems: 1;

  overflow-x: hidden;

  ${SectionWrapperStyles.SiteWide} {
    ${baseGrid};
  }

  @media ${from(Device.TabletLarge)} {
    ${SectionWrapperStyles.Inner} {
      padding-bottom: 0;
    }
  }
`;
const CarouselArea = styled.div `
  grid-column: 1 / span 12;
  overflow: hidden;

  @media ${from(Device.TabletLarge)} {
    grid-column: 2 / span 8;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: 2 / span 7;
  }
`;
const Track = styled(MotionTrack) `
  margin-right: calc(var(--itemGutter) * -0.5);
  margin-left: calc(var(--itemGutter) * -0.5);
`;
const Item = styled.li `
  display: block;
  flex: 0 0 calc(100% / var(--visibleItems));
  padding-right: calc(var(--itemGutter) * 0.5);
  padding-left: calc(var(--itemGutter) * 0.5);
`;
const PaginationWrapper = styled.div `
  margin: 2rem 0 0;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  align-items: center;
  grid-column: 1 / span 12;

  @media ${from(Device.TabletLarge)} {
    margin: calc((${fluid(48, 50)} + ${fluid(22, 26)}) * -1) 0 ${fluid(22, 26)};
  }
`;
const Pagination = styled.div `
  @media ${until(Device.Tablet)} {
    order: 1;
  }
`;
const StyledControls = styled(Controls) `
  justify-self: end;
  display: flex;
  gap: ${fluid(10, 12)};
`;
const TestimonialCarouselStyles = {
    CarouselArea,
    Container,
    Controls: StyledControls,
    Item,
    Pagination,
    PaginationWrapper,
    Track,
};
export default TestimonialCarouselStyles;
